export const enum ReceiverAction {
  START = 0,
  YIELD = 25,
  RESPONSE = 50,
  STOP = 100,
}
